import { useEffect, useState } from 'react'
import { useApi } from '../classes/appApi'
import { useOffline } from '../components/App/AppOfflineContext'
import { useRouterContext } from '../components/App/AppRouter'
import BusinessFunctionBadge from '../components/BusinessFunctionBadge'
import MainLayout from '../components/MainLayout'
import { ContinuumFormSummaryModel } from '../defs/defs'
import EqxCard from '../shared/components/EqxCard/EqxCard'
import EqxFilter from '../shared/components/EqxFilter/EqxFilter'
import { EqxLink } from '@equinoxx/react'
import EqxListGroup, { EqxListGroupItem } from '../shared/components/EqxListGroup/EqxListGroup'
import EqxRequestHandler from '../shared/components/EqxRequestHandler/EqxRequestHandler'
import useApiEndpoint from '../shared/hooks/ApiEndpoint'

const PageContinuumFormIndex = () => {
    const api = useApi()
    const { response: forms, loading, error } = useApiEndpoint<ContinuumFormSummaryModel[]>(api, api.endpoints.continuumForms())
    const router = useRouterContext()
    const { isOffline, isFileCached } = useOffline()
    const [filteredForms, setFilteredForms] = useState<ContinuumFormSummaryModel[]>([])

    // Initialize filtered forms when data loads
    useEffect(() => {
        if (forms) {
            setFilteredForms(forms)
        }
    }, [forms])

    return (
        <MainLayout pageTitle="Forms">
            <EqxRequestHandler
                state={{ loading, error: error ?? null }}
                isEmpty={forms?.length === 0}
                empty={<div className="p-5 text-center text-muted">No forms found</div>}
            >
                <EqxCard isSection noPadding header={
                    <EqxFilter
                        data={forms!}
                        onFilterChange={setFilteredForms}
                        placeholder="Search forms by title or reference..."
                        searchKeys={['title', 'reference']}
                    />
                }>
                    {filteredForms && filteredForms.length > 0 ? (
                        <EqxListGroup isChild>
                            {filteredForms.map((form) => (
                                <EqxListGroupItem key={form.id}>
                                    <div className="clickable d-flex" onClick={() => router.navigate(`/forms/${form.id}`)}>
                                        <div className="m-1 me-3">{form.businessFunction && <BusinessFunctionBadge businessFunction={form.businessFunction} />}</div>
                                        <div className="flex-grow-1">
                                            <h6 className="mb-0"><EqxLink to={`/forms/${form.id}`} className={isOffline && !isFileCached(`/continuum-forms/${form.id}`) ? 'unavailable' : ''}>{form.title}</EqxLink></h6>
                                            <div className="small text-muted">{form.reference}</div>
                                        </div>
                                    </div>
                                </EqxListGroupItem>
                            ))}
                        </EqxListGroup>
                    ) : (
                        <div className="p-5 text-center text-muted">
                            {forms && forms.length > 0 ? 'No forms match your search criteria' : 'No forms found'}
                        </div>
                    )}
                </EqxCard>
            </EqxRequestHandler>
        </MainLayout>
    )
}

export default PageContinuumFormIndex 